export default "__VITE_ASSET__B2wgEOv$__"